import { reconnect } from 'lib/resource';

import inventoriesResource from '../inventories.resource';
import InventoryAudit from './InventoryAudit';

export default reconnect((state, props) => ({
  inventoryAudit: (inventoriesResource as any).audit(state, { id: props.inventoryAuditId }),
}))(class extends InventoryAudit {});
